import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../../../../../../CurrentUserStore';
import { findLinkBy } from '../../../../../../../../../Links';
import { previewStore } from '../../../../../LearningCollectionPreviewStore';
import BaseLayout from '../../../../../../shared/SaveActions/BaseLayout';
import CancelButton from '../../../../../../shared/SaveActions/CancelButton';
import CreateWithoutPublishingButton from '../../../../../../shared/SaveActions/CreateWithoutPublishingButton';
import PublishButton from '../../../../../../shared/SaveActions/PublishButton';
import OtherCreateOptions from './OtherCreateOptions';

function Waiting() {
  const actionButtons = findLinkBy({ rel: 'publish' }, currentUserStore.links)
    .map(() => (
      <div className="flex items-center">
        <PublishButton onClick={() => previewStore.startPublishing()} />
        <OtherCreateOptions />
      </div>
    ))
    .getOrElse(() => (
      <div className="flex items-center">
        <CreateWithoutPublishingButton onClick={() => previewStore.startCreating()} />
        <OtherCreateOptions showCreateWithoutPublishing={false} />
      </div>
    ));

  return (
    <BaseLayout>
      <CancelButton onClick={() => previewStore.showCancelConfirmation()} />
      {actionButtons}
    </BaseLayout>
  );
}

export default observer(Waiting);
